// App Transitions - Native-like page transition animations

let initialized = false;

function initTransitions(): void {
  if (initialized) return;
  initialized = true;

  // Inject animation styles once
  const style = document.createElement('style');
  style.textContent = `
    @keyframes appFadeIn {
      from { opacity: 0; transform: translateY(3px); }
      to { opacity: 1; transform: translateY(0); }
    }
    #app-content.app-entering {
      animation: appFadeIn 150ms ease-out forwards;
    }
  `;
  document.head.appendChild(style);

  // Apply fade-in animation after Turbo navigations
  document.addEventListener('turbo:load', () => {
    const content = document.getElementById('app-content');
    if (!content) return;

    content.classList.add('app-entering');
    setTimeout(() => content.classList.remove('app-entering'), 160);

    updateActiveTab();
  });
}

function updateActiveTab(): void {
  const tabs = document.querySelectorAll('.bottom-tab-item');
  if (!tabs.length) return;

  const currentPath = window.location.pathname;

  tabs.forEach((tab) => {
    const href = tab.getAttribute('href') || '';
    const isActive = currentPath === href ||
      (href !== '/main' && href !== '/' && currentPath.startsWith(href));
    tab.classList.toggle('active', isActive);
  });
}

// Initialize
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initTransitions);
} else {
  initTransitions();
}

export { initTransitions };
